import React from 'react';
import authService from '../../services/authService';

const presets = [
  { key: '1d', label: '1d', days: 1 },
  { key: '7d', label: '7d', days: 7 },
  { key: '30d', label: '30d', days: 30 },
];

export default function UserUsage() {
  const [range, setRange] = React.useState('7d');
  const [start, setStart] = React.useState(null);
  const [end, setEnd] = React.useState(null);
  const [summary, setSummary] = React.useState(null);
  const [ledger, setLedger] = React.useState({ total: 0, page: 1, pageSize: 25, items: [] });
  const [loading, setLoading] = React.useState(false);

  const computeDates = React.useCallback(() => {
    const now = new Date();
    let s = null, e = null;
    const preset = presets.find(p => p.key === range);
    if (preset) {
      e = now;
      s = new Date(now.getTime() - preset.days * 24 * 60 * 60 * 1000);
    }
    return { s, e };
  }, [range]);

  const load = React.useCallback(async (page = 1, pageSize = 25) => {
    try {
      setLoading(true);
      const t = authService.getToken && authService.getToken();
      const { s, e } = computeDates();
      const qs = new URLSearchParams();
      qs.set('page', String(page));
      qs.set('pageSize', String(pageSize));
      if (s) qs.set('start', s.toISOString());
      if (e) qs.set('end', e.toISOString());
      const r1 = await fetch(`/api/billing/usage-summary?${qs.toString()}`, { headers: t ? { Authorization: `Bearer ${t}` } : {}, credentials: 'include' });
      if (r1.ok) setSummary(await r1.json());
      const r2 = await fetch(`/api/billing/ledger?${qs.toString()}`, { headers: t ? { Authorization: `Bearer ${t}` } : {}, credentials: 'include' });
      if (r2.ok) setLedger(await r2.json());
    } finally {
      setLoading(false);
    }
  }, [computeDates]);

  React.useEffect(() => { load(1, 25); }, [range, load]);

  const dollars = (c) => `$${((c||0)/100).toFixed(2)}`;

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 1100 }}>
        <h2 style={{ marginTop: 0 }}>Usage</h2>
        <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8 }}>
          {presets.map(p => (
            <button key={p.key} className={range===p.key?'primary':''} onClick={()=>setRange(p.key)}>{p.label}</button>
          ))}
        </div>
        {summary && (
          <div style={{ display:'flex', gap:16, flexWrap:'wrap', marginBottom:12 }}>
            <div><strong>Requests:</strong> {summary.totalRequests}</div>
            <div><strong>Tokens In:</strong> {summary.totalInputTokens.toLocaleString()}</div>
            <div><strong>Tokens Out:</strong> {summary.totalOutputTokens.toLocaleString()}</div>
            <div><strong>Cost:</strong> {dollars(summary.totalCostCents)}</div>
          </div>
        )}
        <div className="table-scroll">
          <table className="admin-table">
            <thead><tr><th>Date</th><th>Provider</th><th>Model</th><th>In</th><th>Out</th><th>Cost</th><th>Balance</th><th>Reason</th></tr></thead>
            <tbody>
              {(ledger.items||[]).map(i => (
                <tr key={i.id}>
                  <td>{new Date(i.occurredAt).toLocaleString()}</td>
                  <td>{i.provider||''}</td>
                  <td>{i.model||''}</td>
                  <td>{i.inputTokens??''}</td>
                  <td>{i.outputTokens??''}</td>
                  <td>{dollars(i.costCents)}</td>
                  <td>{i.balanceAfterCents!=null ? dollars(i.balanceAfterCents) : '—'}</td>
                  <td>{i.reason||''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="admin-pager" style={{ marginTop: 8 }}>
          <button disabled={ledger.page<=1} onClick={()=>load(ledger.page-1, ledger.pageSize)}>Prev</button>
          <span>Page {ledger.page} of {Math.max(1, Math.ceil((ledger.total||0)/(ledger.pageSize||25)))}</span>
          <button disabled={ledger.page >= Math.ceil((ledger.total||0)/(ledger.pageSize||25))} onClick={()=>load(ledger.page+1, ledger.pageSize)}>Next</button>
        </div>
      </div>
    </div>
  );
}


